import { FC, useRef, useState } from 'react';
import styles from './Home.module.scss';
import tokens_1 from '../../data/tokens_1.json';
import TokenForm from '../../components/TokenForm';
import FileUpload from '../../components/FileUpload';

export interface HomeProps {}

async function read(file: any) {
  const str = await file.text();
  console.log(str);
  return JSON.parse(str);
}

export const Home: FC<HomeProps> = (props) => {
  const [imported, setImported] = useState<Record<string, any> | null>(null);
  return (
    <div className={styles.example}>
      <h1>Design Tokens Dictionary - Working Draft</h1>
      <div className='formControl'>
        <label className={styles.uploadLabel} htmlFor='file'>
          Upload Token File
        </label>
        <FileUpload
          onFileSelectSuccess={(file: any) => {
            read(file).then((res) => {
              setImported(res);
              console.log(res);
            });
          }}
        />
      </div>
      <TokenForm initialValues={imported || tokens_1} />
    </div>
  );
};
export default Home;
